import { useParams } from 'react-router';
import { DEFAULT_NETWORK } from '@/constants';

export default function useNetwork(): { network: string } {
  let { network } = useParams();

  if (!network) {
    network = DEFAULT_NETWORK;
  }

  return { network };
}
